import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import ViewerWindow from '../containers/ViewerWindow';
import TypeSelector from '../containers/common/TypeSelector';

import Controller from '../containers/Controller';
import ItemsCarousel from '../containers/common/ItemsCarousel';

const Customizer = ({
  getAllAccessoryTypeDataOnTabClick,
  getAccessoryVariantData,
  // getCurrentPartsConfigFromFlatConfig,
  isDataReady
}) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(true);

  const getAccessoryData = () => {
    if (location.pathname.includes('helmet')) {
      getAllAccessoryTypeDataOnTabClick('helmet');
    }
    if (location.pathname.includes('tshirt')) {
      getAllAccessoryTypeDataOnTabClick('tshirt');
      getAccessoryVariantData('TShirt');
    }
    if (location.pathname.includes('jackets')) {
      getAllAccessoryTypeDataOnTabClick('jacket');
    }
  };

  useEffect(() => {
    getAccessoryData();
  }, [location.pathname]);

  // useEffect(() => {
  //   getAccessoryData();
  // }, []);

  return (
    <div className="app-container">
      {location.pathname.includes('helmet') && <TypeSelector />}
      {location.pathname.includes('jackets') && <ItemsCarousel />}
      {isDataReady && (
        <>
          <Controller />
          <ViewerWindow />
        </>
      )}
    </div>
  );
};

Customizer.propTypes = {
  getAllAccessoryTypeDataOnTabClick: PropTypes.func,
  getCurrentPartsConfigFromFlatConfig: PropTypes.func,
  isDataReady: PropTypes.bool
};

export default Customizer;
